import { Alert, Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { editUserByAdmin } from '../../api/api-middleware';
import Modal from '../elements/Modal';
import UserForm from './UserForm';

export default function EditUser({
  user,
  fetchData,
  token,
  setMessage,
  setSnackbarOpen,
}) {
  const [open, setOpen] = useState(false);
  const [userData, setUserData] = useState({});
  const [error, setError] = useState(null);

  useEffect(() => {
    setUserData({ ...user });
  }, [user]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setError(null);
  };

  const handleSubmit = async (values) => {
    setError(null);

    try {
      const user = {
        first_name: values?.first_name,
        last_name: values?.last_name,
        phone_number: values?.phone_number,
      };
      let response = await editUserByAdmin(userData.id, user, token);
      if (!response.ok) {
        const errorResponse = await response.json();
        throw new Error(errorResponse.message);
      }
      fetchData();
      handleClose();
      setMessage('User updated successfully');
      setSnackbarOpen(true);
    } catch (error) {
      setError('Failed to edit user. ' + error.message);
    }
  };

  return (
    <>
      <Button
        variant="text"
        sx={{ cursor: 'pointer', textTransform: 'none', fontSize: 'inherit',  }}
        disableRipple
        onClick={handleClickOpen}>
        Edit User
      </Button>
      <Modal
        open={open}
        width={'xs'}
        modalTitle="Edit User"
        handleClose={handleClose}>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        <UserForm onSubmit={handleSubmit} user={userData} type="edit" />
      </Modal>
    </>
  );
}
